import { ViewFilterDef } from '@recruitee/views-types';

export const getConditionDef = (filterDef: ViewFilterDef, conditionId: string | null) => {
  if (!conditionId) return null;

  return filterDef.conditions.find(conditionDef => conditionDef.id === conditionId) ?? null;
};
